import $ from "@modules/jquery";
import gsap from "@modules/gsap";
import { CustomEase } from "@modules/gsap/CustomEase";

export default function HamburgerMenu() {
    const $body = $("body");
    const $toggleBtn = $("#hamburger-toggle");
    const $mainNav = $("#main-navigation");
    const $hamburgerLayerMobile = $(".hamburger-layer-mobile");
    const $hamburgerLayerDesktop = $(".hamburger-layer-desktop");
    const $lines = $toggleBtn.find(".hamburger-bar");
    const $layer = $("#hamburger-menu-layer");

    const customEase = "M0,0 C0.742,0 0.2,1 1,1";

    gsap.registerPlugin(CustomEase);

    function updateHamburgerLayerHeight() {
        const headerHeight = $("header").outerHeight() || 0;
         const viewportHeight = window.visualViewport 
        ? window.visualViewport.height 
        : window.innerHeight;
        const newHeight = viewportHeight - headerHeight;

        gsap.set([$hamburgerLayerDesktop, $hamburgerLayerMobile], {
            height: newHeight,
        });
    }


    updateHamburgerLayerHeight();
    window.addEventListener("resize", updateHamburgerLayerHeight);

    // === Animazioni Icona ===
    function openIconAnimation() {
        gsap.to($lines.eq(1), {
            duration: 0.2,
            opacity: 0,
            ease: CustomEase.create("custom", customEase),
        });

        gsap.to($lines.eq(0), {
            y: 11,
            rotate: 45,
            duration: 0.3,
            ease: CustomEase.create("custom", customEase),
        });

        gsap.to($lines.eq(2), {
            y: -11,
            rotate: -45,
            duration: 0.3,
            ease: CustomEase.create("custom", customEase),
        });
    }

    function closeIconAnimation() {
        gsap.to($lines.eq(1), {
            duration: 0.2,
            opacity: 1,
            ease: CustomEase.create("custom", customEase),
        });

        gsap.to([$lines.eq(0), $lines.eq(2)], {
            y: 0,
            rotate: 0,
            duration: 0.3,
            ease: CustomEase.create("custom", customEase),
        });
    }

    // === Animazioni Layer ===
    function openLayerAnimation() {
        gsap.fromTo($layer,
            { height: 0 },
            {
                height: '100vh',
                duration: 1,
                ease: CustomEase.create("custom", customEase),
                onStart() {
                    $body.addClass("hamburger-menu-layer-activated");
                    $('.brand-logo').addClass("brand-logo-menu-open");
                },
                onComplete() {
                    $body.css("overflow-y", "hidden");
                    $layer.removeAttr("inert");
                    $layer.attr("aria-hidden", "false");
                   

                }
            }
        );
    }
    
    function closeLayerAnimation() {
        $body.css("overflow-y", "auto");
        gsap.to($layer, {
            height: 0,
            duration: 1,
            ease: CustomEase.create("custom", customEase),
            onComplete() {
                $('.brand-logo').removeClass("brand-logo-menu-open");
                    $layer.attr("aria-hidden", "true").attr("inert", "true");
                   
            }
        })
        $body.removeClass("hamburger-menu-layer-activated");
    
    }

    // === Click Handler ===
    $toggleBtn.on("click", function () {
        const $this = $(this);
        const isOpen = $this.attr("aria-expanded") === "true";
        const lang = document.documentElement.lang || "it";

        const labels = {
            it: {
                open: "Apri menu di navigazione",
                close: "Chiudi menu di navigazione",
            },
            de: {
                open: "Navigationsmenü öffnen",
                close: "Navigationsmenü schließen",
            },
        };

        $this.attr("aria-expanded", String(!isOpen));
        $this.attr("aria-label", isOpen ? labels[lang]?.open : labels[lang]?.close);

        // $body.toggleClass("hamburger-menu-layer-activated", !isOpen);
        $mainNav.prop("hidden", isOpen);

        if (isOpen) $this.trigger("focus");

        const target = $this.attr("data-target-layer");
        const $targetLayer = $(target);

        if (!isOpen) {
            openIconAnimation();
            openLayerAnimation();

            $targetLayer.removeClass("not-display").attr("aria-hidden", "false");
            $targetLayer.find("a, button, input, [tabindex]:not([tabindex='-1'])").first().trigger("focus");
        } else {
            closeIconAnimation();
            closeLayerAnimation();

            const $sublayer = $this.closest(".hamburger-layer-mobile-sublayer");
            $sublayer.addClass("not-display").attr("aria-hidden", "true");

            const $relatedBtn = $(`.sublayer-btn-open[data-target-layer="#${$sublayer.attr("id")}"]`);
            if ($relatedBtn.length) $relatedBtn.trigger("focus");
        }

        $(".sublayer-btn-open").on("click", function () {
            const $this = $(this);
            const targetSelector = $this.attr("data-target-layer");
            const $targetLayer = $(targetSelector);

            if ($targetLayer.length) {
                $targetLayer.removeClass("not-display").attr("aria-hidden", "false");
                $targetLayer.find("a, button, input, [tabindex]:not([tabindex='-1'])").first().trigger("focus");
            }
        });

        $(".sublayer-btn-close").on("click", function () {
            const $sublayer = $(this).closest(".hamburger-layer-mobile-sublayer");
            $sublayer.addClass("not-display").attr("aria-hidden", "true");

            const $relatedBtn = $(`.sublayer-btn-open[data-target-layer="#${$sublayer.attr("id")}"]`);
            if ($relatedBtn.length) $relatedBtn.trigger("focus");
        });
    });
}
